import { render, staticRenderFns } from "./moveToStore.vue?vue&type=template&id=a8add466"
import script from "./moveToStore.vue?vue&type=script&lang=js"
export * from "./moveToStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports